module.exports = [{"value":0,"label":"流行"},{"value":1,"label":"民谣"},{"value":2,"label":"摇滚"},{"value":4,"label":"嘻哈/说唱"},{"value":8,"label":"民族音乐"},{"value":9,"label":"雷鬼"},{"value":10,"label":"金属"},{"value":11,"label":"爵士"},{"value":12,"label":"古典"},{"value":13,"label":"原声/纯音乐"},{"value":15,"label":"戏曲/曲艺"},{"value":17,"label":"动漫/游戏"},{"value":18,"label":"古风"},{"value":20,"label":"儿童音乐"},{"value":99,"label":"其他"},{"value":101,"label":"电子"},{"value":102,"label":"中国风"},{"value":103,"label":"新世纪"},{"value":104,"label":"拉丁"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/audio_style.json
// module id = /4Lp
// module chunks = 1